import httpClient from "httpClient"

const post = (request) => {

    const pathname = '/agenda'
    
    const body = {...request, idUnidade: process.env.REACT_APP_ID_UNIDADE || '' }
    
    return httpClient.post(pathname, body)   
    
}

const agenda = {
    post,
}

export default agenda
